export enum FeedbackType {
	HELPFULNESS = 'helpfulness',
	INAPPROPRIATE = 'inappropriate'
}

export enum VoteType {
	NEGATIVE = 'Negative',
	NONE = 'None',
	POSITIVE = 'Positive'
}